import { render, staticRenderFns } from "./shift-view-info-main.vue?vue&type=template&id=538cd948&scoped=true"
import script from "./shift-view-info-main.vue?vue&type=script&lang=js"
export * from "./shift-view-info-main.vue?vue&type=script&lang=js"
import style0 from "./shift-view-info-main.vue?vue&type=style&index=0&id=538cd948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538cd948",
  null
  
)

export default component.exports